module.exports = "<div class=\"weui_msg\">\n  <div class=\"weui_icon_area\" v-if=\"icon\">\n    <i :class=\"['weui_icon_msg', 'weui_icon_' + icon]\"></i>\n  </div>\n  <div class=\"weui_text_area\">\n    <h2 class=\"weui_msg_title\" v-if=\"title\">{{title}}</h2>\n    <div class=\"weui_msg_desc\"><slot name=\"content\"></slot></div>\n  </div>\n  <div class=\"weui_opr_area\">\n    <slot name=\"operation\"></slot>\n  </div>\n  <div class=\"weui_extra_area\">\n    <slot name=\"extra\"></slot>\n  </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/message/message.vue
 ** module id = 111
 ** module chunks = 0
 **/